<script setup lang="ts">
/**
 * BranchName — the canonical branch-name renderer.
 *
 * Brand comes first, followed by the branch name. Known Lucky prefixes are
 * stripped because the compact SUKI/BBQ badge already communicates the brand.
 */
import { computed } from 'vue';
import { stripBrandPrefix } from '@/lib/display';
import { brandShortTag, brandTagFromName } from '@/lib/brand';
import BrandTag from '@/components/BrandTag.vue';

const props = defineProps<{
  name: string | null | undefined;
  code?: string | null;
}>();

const displayName = computed(() => stripBrandPrefix(props.name ?? ''));
const brandLabel = computed(() => brandShortTag(props.code) || brandTagFromName(props.name));
</script>

<template>
  <span class="branch-name">
    <BrandTag :code="code" :name="name" />
    <span v-if="brandLabel" aria-hidden="true"> </span>
    <span class="branch-name__text">{{ displayName }}</span>
  </span>
</template>
